import { useAuthStore } from "@/stores/authStore"
import { useOrganizationsStore } from "@/stores/organizationsStore"
import { useTcmSummary } from "../hooks"
import { isPearView } from "../lib/board"

/**
 * Which TCM view the signed-in user gets.
 *
 * Inside a clinic's organization everyone, superusers included, sees only that
 * clinic. Only a superuser in one of Pear's own (internal) organizations, as
 * /tcm/summary names them, gets the cross-clinic view. Anything else, including
 * a clinic with no TCM cases or a summary that failed to load, is one clinic.
 */
export function useTcmView() {
  const orgId = useOrganizationsStore((s) => s.selectedOrganizationId)
  const isSuperuser = !!useAuthStore((s) => s.user?.is_superuser)
  const summary = useTcmSummary(!!orgId)
  const clinics = summary.data?.clinics ?? []
  const pearView = isPearView(isSuperuser, orgId, summary.data)
  const ehrFor = (organizationId: string) =>
    clinics.find((c) => c.organization_id === organizationId)?.ehr_name ?? "EHR"
  return { orgId, isSuperuser, summary, clinics, pearView, ehrFor }
}
